import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { history } from "../../../../store/configure/configureStore";
import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import queryString from "query-string";
//
import { getMobileAppUserById } from "../../../../store/mobileAppUserManagement/mobileAppUserManagementActions";
//
import MobileUserDetailsView from "./MobileUserDetailsView";

class MobileUserDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {}

  componentDidMount() {
    // Accessing the URL params
    const userId = this.props.match.params.id;
    this.props.getMobileAppUserById(userId);
  }

  componentWillUnmount() {}

  onClickCancel = () => {
    history?.goBack();
  };

  render() {
    const { mobileUserDataById } = this.props;
    return (
      <MobileUserDetailsView
        mobileUserDataById={mobileUserDataById}
        //handler functions
        onClickCancel={this.onClickCancel}
      />
    );
  }
}

MobileUserDetailsContainer.propTypes = {};

const mapStateToProps = (state) => ({
  mobileUserDataById: state.mobileUserManagement.mobileUserDataById,
});

export default connect(mapStateToProps, { getMobileAppUserById })(
  MobileUserDetailsContainer
);
